<template>
  <div>
    <div class="p-col-12">
      <div class="card">
        <div class="row">
          <div class="col-10 mt-1">
            <h4>List of Permissions</h4>
          </div>
          <div class="col-2">
            <Button
              label="Update Permissions"
              class="p-button-success p-mr-2"
              style="margin-right: 1em"
              @click="updatePermissions = !updatePermissions"
            />
          </div>
        </div>
      </div>
    </div>

    <div style="overflow-x: scroll;">
      <PermissionsTable
        :permissions="permissions"
        :loading="loading"
        @load="loading = !loading"
        :up="updatePermissions"
        @edit-data="editPermission"
        @delete-data="deletePermissionConfirmation"
        @saved="saved"
      />
    </div>

    <PermissionsForm
      :role="role1"
      :permissionsForm="permissionsFormDialog"
      :reloadForm="reloadPermissionsForm"
      :disabledArr="disabledArr"
      :permissionToEdit="permission"
      :activePermissions="activePermissions"
      @close="permissionsFormDialog = false"
      @saved="saved"
      @updated="updated"
    />

    <Dialog
      header="Confirmation"
      :visible.sync="displayConfirmation"
      :style="{ width: '350px', overflowY: 'auto' }"
      :modal="true"
    >
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
        <span>Do you wish to delete the Permission?</span>
      </div>
      <template #footer>
        <Button
          label="No"
          icon="pi pi-times"
          @click="displayConfirmation = false"
          class="p-button-text"
        />
        <Button
          label="Yes"
          icon="pi pi-check"
          @click="deletePermission"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import RoleService from "@/service/RoleService";

import PermissionsTable from "../../universalComponents/roles/PermissionsTable.vue";
import PermissionsForm from "../../universalComponents/roles/PermissionsForm.vue";

export default {
  components: {
    PermissionsTable,
    PermissionsForm
  },
  created() {
    this.role1 = { ...this.role };
    this.getActivePermissions();
  },
  props: ["role"],
  data: () => ({
    roleService: new RoleService(),
    role1: {},
    permissions: [],
    loading: false,
    permission: {},
    displayConfirmation: false,
    activePermissions: [],
    permissionsFormDialog: false,
    reloadPermissionsForm: 0,
    disabledArr: [],
    updatePermissions: false
  }),
  watch: {
    role(val) {
      this.role1 = val;
    },
    role1() {
      this.getPermissions();
    }
  },
  methods: {
    openNew() {
      this.permission = {};
      this.disabledArr = [];
      this.permissionsFormDialog = true;
      this.reloadPermissionsForm++;
    },
    getActivePermissions() {
      this.roleService
        .getActivePermissions()
        .then(data => {
          this.activePermissions = data;
        })
        .catch(error => {
          this.loading = false;
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "activePermissions}"'
          });
        });
    },
    getPermissions() {
      if (this.role1 && this.role1.id) {
        this.loading = true;

        this.roleService
          .getRolePermissions(this.role1.id)
          .then(data => {
            this.loading = false;
            this.permissions = data;
          })
          .catch(error => {
            this.loading = false;
            this.$store.dispatch("addErrorMessage", {
              severity: "error",
              content:
                'Some data was not loaded from "rolePermissions/{roleId}"'
            });
          });
      }
    },
    editPermission(permission) {
      this.permissionsFormDialog = true;
      this.reloadPermissionsForm++;
    },
    deletePermissionConfirmation(permission) {
      this.permission = permission;
      this.displayConfirmation = true;
    },
    deletePermission() {
      this.displayConfirmation = false;
      if (this.permission && this.permission.id) {
        this.roleService
          .deleteRolePermissions(this.permission.id)
          .then(data => this.getPermissions())
          .catch(error => {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while deleting permission",
              life: 5000
            });
          });
      }
    },
    saved(permission) {
      this.getPermissions();
      this.permissionsFormDialog = false;
    },
    updated(permission) {
      console.log("permission updated", permission);
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  padding: 0.5rem 1.5rem;
  margin-bottom: 0rem;
}
</style>
